module.exports = __webpack_public_path__ + "img/15.02a5045e.jpg";